
import UfsInputWithButton from '../inputs/UfsInputWithButton.vue';
import emailValidation from '~/mixins/emailValidation.js';
export default {
  components: { UfsInputWithButton },
  mixins: [emailValidation],
  data () {
    return {
      email: '',
      loading: false,
      success: false
    };
  },
  computed: {
    validEmail () {
      return this.validateEmail(this.email);
    }
  },
  methods: {
    async signUpToNewsletter () {
      try {
        this.loading = true;
        const payload = {
          email: this.email
        };

        await this.$axios.$post('api/newsletter/signup', payload);
        // console.log(res);
        this.success = true;
      } catch (err) {
        // console.log(err);
      } finally {
        this.loading = false;
      }
    }
  }
};
